import Badge from "components/library/Badge";
import { HumanloopLogo } from "components/library/Logos";
import {
  ABOUT_PAGE_LINK,
  CAREERS_LINK,
  GITHUB_LINK,
  HUMANLOOP_CAREERS_LINK,
  HUMANLOOP_DOCS_LINK,
  LINKEDIN_LINK,
  PRICING_PAGE_LINK,
  PROGRAMMATIC_PAGE_LINK,
  SLACK_LINK,
  TWITTER_LINK,
} from "utils/constants";
import NewsletterSignUp from "./NewsletterSignUp";

interface FooterLink {
  title: string;
  url: string;
  display?: JSX.Element;
}

const FooterLinks: Record<string, FooterLink[]> = {
  Resources: [
    {
      title: "Blog",
      url: "/blog",
    },
    {
      title: "API Docs",
      url: HUMANLOOP_DOCS_LINK,
    },
    // {
    //   title: "Slack",
    //   url: SLACK_LINK,
    //   display: (
    //     <span className="flex items-center gap-8">
    //       Slack <Badge>Join us!</Badge>
    //     </span>
    //   ),
    // },
  ],
  Company: [
    {
      title: "Careers",
      display: (
        <span className="flex items-center gap-8">
          Careers <Badge>5</Badge>
        </span>
      ),
      url: CAREERS_LINK,
    },
    {
      title: "About",
      url: ABOUT_PAGE_LINK,
    },
  ],
  Product: [
    // {
    //   title: "Pricing",
    //   url: PRICING_PAGE_LINK,
    // },
    {
      title: "Programmatic",
      url: PROGRAMMATIC_PAGE_LINK,
    },
  ],
  Social: [
    {
      title: "Twitter",
      url: TWITTER_LINK,
    },
    {
      title: "GitHub",
      url: GITHUB_LINK,
    },
    {
      title: "LinkedIn",
      url: LINKEDIN_LINK,
    },
  ],
};

export const Footer = () => {
  return (
    <div>
      <div className="container-xl flex flex-col items-start justify-between gap-y-32 py-60 sm:py-120 xl:flex-row">
        <div className="mr-120 grow">
          <HumanloopLogo className="h-28 shrink-0" />
        </div>
        {/* Links */}
        <div className="grid w-full shrink grid-cols-2 gap-y-32 md:grid-cols-4">
          {Object.entries(FooterLinks).map(([section, links]) => (
            <div
              key={section}
              className="flex flex-col justify-start gap-8 text-14-20"
            >
              <span className="text-gray-600">{section}</span>
              {links.map(({ title, url, display }) => (
                <a
                  key={title}
                  href={url}
                  className="text-gray-900 hover:underline"
                >
                  {display || title}
                </a>
              ))}
            </div>
          ))}
        </div>
        <div className="grow">
          <NewsletterSignUp />
        </div>
      </div>

      <div className="shrink">
        <div className="container-xl flex justify-between gap-12 border-t border-gray-300 py-24 text-11-14 text-gray-600 sm:py-36 sm:text-14-16">
          <div>© 2020 - 2045 Humanloop, Inc.</div>
          <div className="flex gap-32">
            <a href={"/terms"} className="hover:text-gray-900">
              Terms
            </a>
            <a href={"/privacy"} className="hover:text-gray-900">
              Privacy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
